var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG__x2B__stroke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1h92c1.7 0 3 1.3 3 3v52c0 1.7-1.3 3-3 3H4c-1.7 0-3-1.3-3-3V4c0-1.7 1.3-3 3-3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96 2c1.1 0 2 .9 2 2v52c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h92m0-2H4C1.8 0 0 1.8 0 4v52c0 2.2 1.8 4 4 4h92c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4z",
    fill: "#e9e9e9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "visa_new"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00589f",
    d: "M39.6 38.8L42.1 24h4.1l-2.5 14.8zM58.3 24.4c-.8-.3-2.1-.6-3.6-.6-4 0-6.8 2-6.8 4.9 0 2.1 2 3.3 3.5 4 1.6.7 2.1 1.2 2.1 1.8 0 1-1.3 1.5-2.4 1.5-1.6 0-2.5-.2-3.8-.8l-.5-.2-.6 3.3c.9.4 2.7.8 4.5.8 4.3 0 7-2 7.1-5.1 0-1.7-1.1-3-3.4-4-1.4-.7-2.3-1.1-2.3-1.8 0-.6.7-1.3 2.3-1.3 1.3 0 2.3.3 3 .6l.4.2.5-3.3M68.7 24h-3.1c-1 0-1.7.3-2.1 1.2l-6 13.6h4.3s.7-1.8.9-2.2h5.2c.1.5.5 2.2.5 2.2H72L68.7 24m-5 9.6c.3-.9 1.6-4.2 1.6-4.2s.3-.9.5-1.4l.3 1.3s.8 3.5.9 4.3h-3.3zM36.2 24l-4 10.1-.4-2.1c-.7-2.4-3-4.9-5.6-6.2l3.6 13h4.3L40.5 24h-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6 24H22v.3c5.1 1.2 8.4 4.2 9.8 7.8l-1.4-6.8c-.2-1-.9-1.3-1.8-1.3",
    fill: "#f9a51a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.606fc1704316676386161208e47c877b.svg";
export { ForwardRef as ReactComponent };